/**
 * herd
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * OpenAPI spec version: 0.220.0-SNAPSHOT
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { Parameter } from './parameter';
import { WorkflowError } from './workflowError';
import { WorkflowStep } from './workflowStep';


export interface Job { 
    /**
     * The internal identifier that uniquely references a job
     */
    id: string;
    /**
     * The status of the job. One of the following values: RUNNING, SUSPENDED, COMPLETED
     */
    status?: Job.StatusEnum;
    /**
     * The namespace of the job
     */
    namespace?: string;
    /**
     * The name of the job
     */
    jobName?: string;
    /**
     * The start time of the job
     */
    startTime?: Date;
    /**
     * The end time of the job. It is not returned for a job in RUNNING state
     */
    endTime?: Date;
    currentWorkflowStep?: WorkflowStep;
    /**
     * The steps that have been completed. For a job in RUNNING state, steps up to the last Async task will be returned. For a job in                   COMPLETED state, all executed steps will be returned                
     */
    completedWorkflowSteps?: Array<WorkflowStep>;
    /**
     * Current workflow variables and values
     */
    parameters?: Array<Parameter>;
    /**
     * Activiti workflow XML related to the job
     */
    activitiJobXml?: string;
    /**
     * The workflow errors
     */
    workflowErrors?: Array<WorkflowError>;
    /**
     * A reason this job has been deleted. It is returned if the job has been deleted
     */
    deleteReason?: string;
}
export namespace Job {
    export type StatusEnum = 'RUNNING' | 'SUSPENDED' | 'COMPLETED';
    export const StatusEnum = {
        RUNNING: 'RUNNING' as StatusEnum,
        SUSPENDED: 'SUSPENDED' as StatusEnum,
        COMPLETED: 'COMPLETED' as StatusEnum
    };
}
